export class Habilitation {
  habilitationId: number;
  habilitationLibelle: string;
}
